import React from "react";
import { Image } from "@catchoftheday/cg-components";
import { ASSET_WOMAN_CARRYING_DIVISION_BOXES } from "../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellBoxSideImage = function UpsellBoxSideImage() {
  return ___EmotionJSX(Image, {
    src: ASSET_WOMAN_CARRYING_DIVISION_BOXES,
    alt: "Woman carrying boxes with divisions' logos on them",
    width: "auto",
    mb: {
      xs: "-15%",
      md: -6
    }
  });
};